// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".VueCarousel-dot-button{transition:all .3s}.VueCarousel-dot--active .VueCarousel-dot-button{border-radius:10px!important;width:30px!important;height:8px!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
